import {ContainerBinder} from '../../../../IoC/ContainerBinder';
import {CromExpandJrpc} from '../domain/Crom/mappers/jrpc/Crom.expand.jrpc';
import {CromMapperJrpc} from '../domain/Crom/mappers/jrpc/Crom.mapper.jrpc';
import {FetchCromByIdQuery} from '../ports/fetchCromById/FetchCromById.query';
import {FetchCromByIdQueryJrpc} from '../ports/fetchCromById/jrpc/FetchCromById.query.jrpc';
import {SendCromAnswersCommandJrpc} from '../ports/sendCromAnswers/jrpc/SendCromAnswers.cmd.jrpc';
import {SendCromAnswersCommand} from '../ports/sendCromAnswers/SendCromAnswers.cmd';

export const bindJrpc = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bindSingleton(FetchCromByIdQuery, FetchCromByIdQueryJrpc)
    .bindSingleton(SendCromAnswersCommand, SendCromAnswersCommandJrpc)
    .bindSingleton(CromExpandJrpc)
    .bindSingleton(CromMapperJrpc)
    .done();
};
